import {
  CommandBar,
  getTheme,
  ICommandBarItemProps,
  IconButton,
  SearchBox,
  Stack,
} from "@fluentui/react";
import HeaderGeneric from "./headerGeneric";
import HeaderTable from "./HeaderTable";
// import { IconHelper } from "../../utils/Helper/iconHelper";
const _farItems: ICommandBarItemProps[] = [];
const _onSearchText = (
  event?: React.ChangeEvent<HTMLInputElement>,
  newValue?: string
) => { };
const onSearch = (newValue: string) => { };
const onClear = (ev?: any) => { };

const theme = getTheme();

export function HeadingBar({
  title = "",
  subTitle = "",
  subTitle2 = "",
  itemBar = _farItems,
  searchPlaceholder = "Buscar...",
  searchChange = _onSearchText,
  searchHandler = onSearch,
  searchValue = "",
  searchShow = true,
  onClearHandler = onClear,
}) {
  return (
    <div style={{width:'100%'}}>
      <Stack horizontal padding={10}>
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4">
          {/* <HeaderGeneric title={title} subTitle={subTitle}></HeaderGeneric> */}
          <HeaderTable title={title} subTitle={subTitle} hidenIcon={true} />
        </div>
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4">
          {searchShow && (
            <div className="ms-Grid-row">
              <div className="ms-Grid-col  ms-lg11">
                <SearchBox
                  // underlined
                  placeholder={searchPlaceholder}
                  onSearch={searchHandler}
                  onChange={searchChange}
                  value={searchValue}
                  autoComplete="off"
                  onClear={onClearHandler}
                />
              </div>
            </div>
          )}
        </div>
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4">
          {_farItems.length > 0 || (itemBar.length > 0 && (
            <CommandBar
              items={_farItems}
              farItems={itemBar}
              ariaLabel="Inbox actions"
              primaryGroupAriaLabel="Email actions"
              farItemsGroupAriaLabel="More actions"
            />
          ))}
        </div>
      </Stack>
    </div>
  );
}
